import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import Spinner from 'components/Spinner';

import AuthTemplate from 'components/Auth/index';
import Password from 'app/routes/Auth/routes/Password/index';
import Forgot from 'app/routes/Auth/routes/Forgot/index';
import Pin from 'app/routes/Auth/routes/Pin/index';
import InitialLogin from 'app/routes/Auth/routes/InitialLogin/index';
import Confirm from 'app/routes/Auth/routes/Login/index';
import Company from 'app/routes/Auth/routes/Company/index';
class Auth extends React.Component {
    render() {
        const { match, authUser, theme } = this.props;
        return (
            <Suspense fallback={<Spinner fallback={true} />}>
                <AuthTemplate theme={theme}>
                    <Switch>
                        {authUser && authUser.state === 'update_required' && (
                            <Route path={`${match.url}/password`} component={Password} />
                        )}
                        <Route path={`${match.url}/forgot`} component={Forgot} />
                        <Route path={`${match.url}/confirm`} component={Confirm} />
                        <Route path={`${match.url}/pin`} component={Pin} />
                        <Route path={`${match.url}/company`} component={Company} />
                        <Route path={`${match.url}/:id`} component={InitialLogin} />
                        <Route component={InitialLogin} />
                    </Switch>
                </AuthTemplate>
            </Suspense>
        );
    }
}

const mapStateToProps = ({ auth, app }) => {
    const { authUser } = auth;
    const { theme } = app;
    return { authUser, theme };
};

export default connect(mapStateToProps)(Auth);
